import { render, staticRenderFns } from "./IFPdfIncomeStatement.vue?vue&type=template&id=2b50c502"
import script from "./IFPdfIncomeStatement.vue?vue&type=script&lang=js"
export * from "./IFPdfIncomeStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports